module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/05e05756b592740a3670417b4df19ca9.svg";